import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
function compareVersions(version1, version2) {
  // 将版本号拆分为数组
  var v1 = version1.split('.').map(Number);
  var v2 = version2.split('.').map(Number);
  // 获取最长的版本号长度
  var maxLength = Math.max(v1.length, v2.length);
  // 循环比较每一部分的版本号
  for (var i = 0; i < maxLength; i++) {
    var num1 = v1[i] || 0; // 如果v1长度不够，补0
    var num2 = v2[i] || 0; // 如果v2长度不够，补0
    if (num1 > num2) {
      return true;
    } else if (num1 < num2) {
      return false;
    }
  }
  // 如果所有部分都相等，返回true
  return true;
}
// 示例使用
//  console.log(compareVersions("9.57.0.1", "10.57.2"));  // false
//  console.log(compareVersions("10.57.2", "9.57.0.1"));  // true
//  console.log(compareVersions("9.57.0.0", "9.57.0"));   // true
//  console.log(compareVersions("9.57.0", "9.57.0.1"));   // false

export default compareVersions;